<script>
import { HorizontalBar, mixins } from "vue-chartjs";

export default {
  name: "Bar",
  mixins: [mixins.reactiveProp],
  extends: HorizontalBar,
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      timoutHandle: null 
    };
  },
  watch: {
    chartData() {
      try {
        if (this.chartData !== null)
          this.renderChart(this.chartData, this.options);
      } catch (ex) {
        console.log(ex);
      }
    },
  },
  mounted() {
    try {
      if (this.chartData !== null) {
        this.renderChart(this.chartData, this.options);
      }
    } catch (ex) {
      console.log(ex);
    }
  },
  methods: {
    testAlert()
    {
      console.log('hello');
      //alert('hello');
    },
    testClick(){
      console.log("testClick 3");
    },
  //  handleClick(event, elements) {
  //     if (elements && elements.length) {
  //       const clickedBar = elements[0];
  //       // Handle the click event here
  //       console.log(clickedBar._index); // Index of the clicked bar
  //       console.log(clickedBar._datasetIndex); // Index of the dataset
  //     }
  //   },
    // handleClick(chartId) {
    //   console.log(chartId);
    //   return function(event) {
    //     // Get the chart instance based on the chartId
    //     const chart = this.$refs[chartId].chart;

    //     // Get all clicked elements
    //     const elements = chart.getElementsAtEvent(event);

    //     if (elements && elements.length) {
    //       // Iterate through each clicked element
    //       elements.forEach(element => {
    //         // Access properties of each element
    //         console.log('Chart:', chartId);
    //         console.log('Clicked bar index:', element._index);
    //         console.log('Clicked dataset index:', element._datasetIndex);
    //       });
    //     }
    //   }
    // }
    // handleClick(chartId) {
    //   console.log(chartId);
    //   return function(event) {
    //     // Get the chart instance based on the chartId
    //     const chart = this.$refs[chartId].chart;

    //     // Get all clicked elements
    //     const elements = chart.getElementsAtEvent(event);

    //     if (elements && elements.length) {
    //       // Iterate through each clicked element
    //       elements.forEach(element => {
    //         // Access properties of each element
    //         console.log('Chart:', chartId);
    //         console.log('Clicked bar index:', element._index);
    //         console.log('Clicked dataset index:', element._datasetIndex);
    //       });
    //     }
    //   }
    // }
    // handleClick(event, elements) {
    //   if (elements && elements.length) {
    //     const clickedBar = elements[0];
    //     // Handle the click event here
    //     console.log(clickedBar._index); // Index of the clicked bar
    //     console.log(clickedBar._datasetIndex); // Index of the dataset
    //   }
    // },
    // handleClick(chartIndex) {
    //   return function(event, elements) {
    //     if (elements && elements.length) {
    //       const clickedBar = elements[0];
    //       // Handle the click event here

    //       console.log(this.$refs);
    //       console.log(this.$refs.chart);

    //       console.log(`Chart ${chartIndex} - Bar index: ${clickedBar._index}`);
    //       console.log(`Chart ${chartIndex} - Dataset index: ${clickedBar._datasetIndex}`);
    //     }
    //   }
    // }
    // ,
    // handleClick(event) {
    //   // Get the chart instance
    //   console.log(event);
    //   console.log(this.$refs);
    //   console.log(this.$refs.chart);
    //   // const chart = this.$refs.chart.chart;

    //   // // Get the clicked elements
    //   // const elements = chart.getElementsAtEvent(event);

    //   // if (elements && elements.length) {
    //   //   const clickedBar = elements[0];
    //   //   // Handle the click event here
    //   //   console.log('Clicked bar index:', clickedBar._index);
    //   //   console.log('Clicked dataset index:', clickedBar._datasetIndex);
    //   // }
    // }

  },
};
</script>
